import React from 'react';
import CircleCheckIcon from '../Icons/CircleCheckIcon';

type ListProps = {
  children: React.ReactNode;
  className?: string;
};

const keyFor = (node: React.ReactNode, fallback: number) =>
  React.isValidElement(node) && node.key != null ? String(node.key) : String(fallback);

// Neutral: UL/OL decide how to wrap
export const ListItem: React.FC<{ children: React.ReactNode }> = ({ children }) => <>{children}</>;

export const UnorderedList: React.FC<ListProps> = ({ children, className = '' }) => {
  const items = React.Children.toArray(children);

  return (
    <ul className={`space-y-4 ${className}`.trim()}>
      {items.map((item, idx) => (
        <li
          key={keyFor(item, idx)}
          className='flex gap-4'
        >
          <CircleCheckIcon className='text-brand-icon' />
          <div className='flex-1 font-bold [&_p]:font-inherit [&_p]:m-0 '>{item}</div>
        </li>
      ))}
    </ul>
  );
};

export const OrderedList: React.FC<ListProps> = ({ children, className = '' }) => {
  const items = React.Children.toArray(children);
  return (
    <ol
      className={`
        rich-text-ol
        ml-0 pl-0 list-none
        ${className}
      `.trim()}
    >
      {items.map((item, idx) => (
        <li
          key={keyFor(item, idx)}
          className='mb-10 ml-0 pl-0 clear-both overflow-hidden'
        >
          <span className='ol-marker font-heading text-brand-icon font-bold text-[1.5625rem] leading-[120%] float-left min-w-6 mr-2' />
          <div className='rich-text-ol-body text-primary-500 text-lg leading-[140%] tracking-[-0.01em] [&_p]:m-0'>
            {item}
          </div>
        </li>
      ))}
    </ol>
  );
};
